/**
 * Per-record affordance flags -- GitHub issue #181.
 *
 * THE PROBLEM. `AuthContext.can()` reads /api/auth/me's permission map, which
 * for the six hierarchical resources (documents, hierarchy, workflows,
 * approvals, document_drafts, document_extras) is computed with
 * `any_scope=True` -- meaning "holds this SOMEWHERE", not "at the node this
 * button is about". That is the right answer to the question the map is asked;
 * the frontend was asking a global primitive a local question. So a
 * department-scoped user saw an Edit button on another department's document,
 * clicked it, and got an accurate 403.
 *
 * THE FIX. Every list and detail response for those resources now carries
 * `can_edit` / `can_delete` computed server-side against THAT ROW'S own node
 * (services/record_rights_service.py). This helper is how a component reads
 * one.
 *
 * NULL MEANS "NOT COMPUTED", NOT "DENIED" -- and that distinction is the whole
 * reason the fields are Optional rather than plain booleans. A response built
 * without an identity to hand omits them, so falling back to the caller's own
 * `can()` hint keeps every such surface behaving exactly as it did before. A
 * literal `false` is a real answer and is always honoured.
 *
 * STATUS IS NOT IN HERE. `can_edit` answers the permission question only; the
 * DRAFT-only and open-revision rules stay in the components, which read them
 * off the row. Folding status into the server flag would silently remove
 * "Start Review", which is offered on an ACTIVE document and gated on this
 * same right.
 *
 * AND IT IS STILL AN AFFORDANCE. The server re-checks against the real target
 * on every request and remains the only control.
 */
export function recordRight(flag, fallback = false) {
  return flag === null || flag === undefined ? fallback : flag;
}

export default recordRight;
